const mutations = {
  LOGIN(state, data) {
    state.isLogin = true;
    localStorage.setItem("accesstoken", data);
  },
  LOGOUT(state) {
    state.isLogin = false;
    state.autoLogin = false;
    state.isAdmin = false;
    state.footerVisible = false;
    state.lnbVisible = false;
    state.gnbVisible = false;
    state.adminLnbVisible = false;
    state.adminGnbVisible = false;
    state.isCollapse = false;
    state.userId = "";
    state.email = "";
    state.week = "";
    state.day = "";
    state.mobileNo = "";
    state.username = "";
    state.weddingHall = "";
    localStorage.removeItem("accesstoken");
    localStorage.removeItem("isAdmin");
  },
  SET_USERNAME(state, data) {
    state.username = data;
  },
  SET_MOBILENO(state, data) {
    state.mobileNo = data;
  },

  SET_NAVBAR(state, data) {
    state.navbarState = data;
  },
  SET_MENU_COLLAPSE(state, data) {
    state.isCollapse = data;
  },
  SET_ADMINNAVBAR(state, data) {
    state.adminNavbarState = data;
  },
  SET_FOOTER_VISIBLE(state, data) {
    state.footerVisible = data;
  },
  SET_LNB_VISIBLE(state, data) {
    state.lnbVisible = data;
  },
  SET_ADMINLNB_VISIBLE(state, data) {
    state.adminLnbVisible = data;
  },
  SET_ADMINGNB_VISIBLE(state, data) {
    state.adminGnbVisible = data;
  },
  SET_GNB_VISIBLE(state, data) {
    state.gnbVisible = data;
  },

  SET_NAVBAR_VISIBLE(state, data) {
    state.navVisible = data;
  },
  SET_ALARMCOUNT(state, data) {
    state.alarmCount = data;
  },
  SET_USER_INFO(state, data) {
    localStorage.setItem("isAdmin", data.isAdmin);
    if (data.userId) {
      state.userId = data.userId;
    }
    if (data.email) {
      state.email = data.email;
    }
    if (data.week) {
      state.week = data.week;
    }
    if (data.isAdmin) {
      state.isAdmin = data.isAdmin;
    }
    if (data.day) {
      state.day = data.day;
    }
    if (data.mobileNo) {
      state.mobileNo = data.mobileNo;
    }
    if (data.weddingHall) {
      state.weddingHall = data.weddingHall;
    }

    if (data.username) {
      state.username = data.username;
    }
  },
};
export default mutations;
